import React from 'react';
import { LayersIngredientsProps } from 'business/models/CustomModels';
import { LayerTypeDTO } from 'business/models/Models';
import { ConditionTabContent } from 'components/commandpanel/CustomLayer/CustomLayerContent';
import RandomLayersIngredients from 'components/commandpanel/RandomLayer/RandomLayerIng';
import GridLayerIngredients from 'components/commandpanel/GridLayer/GridLayerIngredients';
import SeedLayerContent from '../SeedingLayer/SeedLayerContent';
import ProteinLayerContent from '../ProteinLayer/ProteinLayerContent';
import { ScreenLayerContent as ScreenLayerContent } from '../ScreenLayer/ScreenLayerContents';
import { useRMSelector } from 'redux/hooks';
import { selectSelectedLayer } from 'redux/selectors/ExperimentStateSelector';
import { FragmentLayerContent } from '../FragmentLayer/FragmentLayerContent';

export function LayersIngredients({
  setContentView,
  setEditIngredientData,
  setSelectedIngredient,
  setSelectedStocks,
  randomLyrActiveGroupId,
  setRandomLyrActiveGroupId,
  setEditSeedData,
  editSeedData,
  setSelectedTab,
}: LayersIngredientsProps) {
  const _selectedLayer = useRMSelector(selectSelectedLayer);
  function getLayerIngredients() {
    const layerType = _selectedLayer.type;
    let ingView = null;
    switch (layerType) {
      case LayerTypeDTO.Grid:
        ingView = (
          <GridLayerIngredients
            setEditIngredientData={setEditIngredientData}
            setContentView={setContentView}
            setSelectedIngredient={setSelectedIngredient}
            setSelectedStocks={setSelectedStocks}
          />
        );
        break;
      case LayerTypeDTO.ConditionList:
        ingView = (
          <ConditionTabContent
            setContentView={setContentView}
            setEditIngredientData={setEditIngredientData}
            setSelectedIngredient={setSelectedIngredient}
            setSelectedTab={setSelectedTab}
          />
        );
        break;
      case LayerTypeDTO.Random:
        ingView = (
          <RandomLayersIngredients
            setContentView={setContentView}
            setEditIngredientData={setEditIngredientData}
            setSelectedIngredient={setSelectedIngredient}
            setSelectedStocks={setSelectedStocks}
            setActiveGroupId={setRandomLyrActiveGroupId}
            activeGroupId={randomLyrActiveGroupId}
          />
        );
        break;

      case LayerTypeDTO.Seed:
        ingView = (
          <SeedLayerContent
            setContentView={setContentView}
            setEditSeedData={setEditSeedData}
            editSeedData={editSeedData}
          />
        );
        break;
      case LayerTypeDTO.Protein:
        ingView = <ProteinLayerContent setContentView={setContentView} />;
        break;
      case LayerTypeDTO.Screen:
        ingView = <ScreenLayerContent setContentView={setContentView} />;
        break;
      case LayerTypeDTO.Fragment:
        ingView = <FragmentLayerContent setContentView={setContentView} />;
        break;
      default:
        break;
    }
    return ingView;
  }

  return <>{getLayerIngredients()}</>;
}

export default LayersIngredients;
